<div *ngIf="show" class="loader-custom">
  <p-progress-spinner
    strokeWidth="5"
    [style]="{ width: '50px', height: '50px' }"
  >
  </p-progress-spinner>
</div>
